import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import image_background from "../../../assets/img/2.jpg";
import { useEffect, useRef } from "react";
import "../../../assets/css/MissionVission.css";
function MissionVission() {

  const parallaxRef = useRef(null);

useEffect(() => {
  const section = parallaxRef.current;
  if (!section) return;

  const background = section.querySelector(
    ".fmhud-parallax-background"
  );

  if (!background) return;

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (reduceMotion) return;

  let frameId = null;

  const updateParallax = () => {
    frameId = null;

    const rect = section.getBoundingClientRect();
    const offset = (window.innerHeight - rect.top) * 0.15;

    background.style.transform = `translate3d(0, ${offset}px, 0)`;
  };

  const onScroll = () => {
    if (frameId === null) {
      frameId = window.requestAnimationFrame(updateParallax);
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);

  updateParallax();

  return () => {
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("resize", onScroll);

    if (frameId !== null) {
      window.cancelAnimationFrame(frameId);
    }
  };
}, []);

  return (
    
<section
  ref={parallaxRef}
  id="featured-official"
  className="featured-official-section fmhud-parallax"
>
  <div
    className="fmhud-parallax-background"
    style={{ backgroundImage: `url("${image_background}")` }}
    aria-hidden="true"
  />

  <div className="fmhud-parallax-overlay" aria-hidden="true" />

  <div className="container fmhud-parallax-content">
    <div className="row align-items-center justify-content-center">
      <div className="col-lg-8 text-start">
        <div className="textControler">
          <h1 className="text-light">
            <strong>TRANSFORMATION</strong>
          </h1>

          <h2 className="text-light">
            Building Sustainable Communities Through Housing and Urban
            Development
          </h2>

          <h3 className="text-light fw-light mb-1 fmhud-parallax-description">
            The Federal Ministry of Housing and Urban Development is
            committed to providing affordable housing, promoting
            sustainable urban planning, and delivering modern
            infrastructure that improves the quality of life for all
            Nigerians. Through strategic policies, innovative housing
            programs, urban renewal projects, and public-private
            partnerships, the Ministry drives national development by
            creating inclusive, resilient, and well-planned communities.
            With a focus on accessibility, transparency, and long-term
            growth, the Ministry remains dedicated to shaping safer cities
            and better living environments across the nation.
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>

  );
}

export default MissionVission;
